export default "__VITE_ASSET__Wc52KiCK__"